import React from 'react';
import { Typography, Box, IconButton, Grid } from '@mui/material';
import { styled } from '@mui/system';
import imgUrl from '../../assets/images/imgUrl';

const BackgroundContainer = styled(Box)({
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  height: '100vh',
  color: '#fff',
  position: 'relative',
});

const Overlay = styled(Box)({
  padding: '1rem',
  display: 'flex',
  alignItems: 'center',
  height: '100%',
});

const FloatingChatButton = styled(IconButton)({
  position: 'fixed',
  bottom: 40,
  right: 16,
  zIndex: 99,
});

function ProductHome() {
  return (
    <>       
      <BackgroundContainer className='homeBackgroundContainer productBackgroundContainer'>
        <Overlay>
          <Grid container>
            <Grid size={{ xs: 12, md: 8 }}>
              <Typography
                variant="h3"
                fontWeight="bold"
                sx={{
                  fontSize: { xs: '2rem', sm: '2.5rem', md: '4rem' },
                  lineHeight: 1.3,
                  maxWidth: { xs: '100%', sm: '100%', md: '100%' },
                  wordBreak: 'break-word',
                  
                }}
              >
                Workflow Based Data Collection
              </Typography>
              <Typography variant='h6'>Enhancing early detection and response <br></br> through a unified surveillance system. </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}></Grid>
          </Grid>
        </Overlay>
      </BackgroundContainer>

      <FloatingChatButton>
        <img src={imgUrl.bot} className='w-100 botIcon' alt="Chatbot" />
      </FloatingChatButton>
    </>
  );
}

export default ProductHome;
